










































import app from "@/app";
import { SXQuestion, SXSurvey, SXChoice } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Watch } from "vue-property-decorator";

const removeFromList = function<T>(item: T, list: Array<T>) {
	let index = list.indexOf(item);
	if (~index) {
		list.splice(index, 1);
	}
};

@Component
export default class WSurveyBuilder extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	dirtyList: SXQuestion[] = [];
	forceDelete = [];
	questions = app.services.surveys.surveyQuestions(this.survey);

	get isDirty() {
		return this.dirtyList.length;
	}

	save() {
		let toSave: object[] = [],
			toUpdate: { [key: string]: {} } = {},
			toDelete: string[] = [].concat(this.forceDelete),
			pos = 0,
			setPos = function(item: SXQuestion, pos: number) {
				if (item.index != pos) {
					item.setIndex(pos);
				}
			};

		if (!this.isDirty) {
			this.questions.forEach(function(item: SXQuestion) {
				if (item.id && item.valid) {
					if (item.valid) {
						setPos(item, pos++);
						if (!item.isSaved()) {
							toUpdate[item.id] = item.toObject(true);
						}
					} else {
						toDelete.push(item.id);
					}
				} else {
					setPos(item, pos++);
					toSave.push(item.toObject(true));
				}
			});

			let modified =
				toSave.length ||
				toDelete.length ||
				Object.keys(toUpdate).length;

			console.log("builder save", {
				list: this.questions,
				toSave,
				toUpdate,
				toDelete
			});

			if (modified) {
				let f =
					this.survey.data === "[]"
						? {}
						: JSON.parse(this.survey.data);
				f["__sx"] = {
					save: toSave,
					update: toUpdate,
					delete: toDelete
				};
				let o = JSON.stringify(f);

				this.survey.setData(o);

				app.services.surveys.updateItem(
					this.survey,
					function() {
						app.view.dialog({
							type: "done",
							text: "SX_LANG_SURVEY_QUESTIONS_SAVED"
						});

						app.router.goBack();
					},
					function() {
						app.view.dialog({
							type: "error",
							text: "SX_LANG_SURVEY_QUESTIONS_SAVE_FAIL"
						});
					},
					true,
					false
				);
			} else {
				app.router.goBack();
			}
		} else {
			app.view.dialog({
				type: "error",
				text: "SX_LANG_SURVEY_IS_DIRTY"
			});
		}
	}
	addQuestion() {
		let q = new SXQuestion();

		q.setUuid(this.ux_uuid()).setSurveyId(this.survey.id);

		this.questions.push(q);
	}
	duplicateQuestion(q: SXQuestion) {
		this.questions.push(this.ux_clone_question(q));
	}
	removeQuestion(q: SXQuestion) {
		if (q.id) {
			this.forceDelete.push(q.id as never);
		}

		removeFromList(q, this.questions);
		removeFromList(q, this.dirtyList);
	}
	onQuestionStateChange(q: SXQuestion, dirty: boolean) {
		if (dirty) {
			this.dirtyList.push(q);
		} else {
			removeFromList(q, this.dirtyList);
		}
	}

	created() {
		if (!this.questions.length) {
			this.addQuestion();
		}
	}
}
